// 以下文件格式为描述路由的协议格式
// 你可以调整 routerConfig 里的内容
// 变量名 routerConfig 为 iceworks 检测关键字，请不要修改名称
import React, { lazy, Suspense } from 'react';

import { Loading } from '@icedesign/base';

import { isELC } from '@/tool/profile';

import Auths from './auth/Auths';
import BlankLayout from './layouts/BlankLayout';
import FactoryLayout from './layouts/FactoryLayout';
import HeaderAsideFooterLayout from './layouts/HeaderAsideFooterLayout';
// 显示面积更大的布局使用这个
// 虽然没用，但是需要其中的大屏样式，所以还是引入一下
// eslint-disable-next-line no-unused-vars
import HeaderAsideFooterResponsiveLayout from './layouts/HeaderAsideFooterResponsiveLayout';

const Empty = lazy(() => import('./pages/Error').then(mod => ({ default: mod.Empty })));
const Password = lazy(() => import('./pages/Profile/Password'));
const Forbidden = lazy(() => import('./pages/Error').then(mod => ({ default: mod.Forbidden })));
const NotFound = lazy(() => import('./pages/Error').then(mod => ({ default: mod.NotFound })));
const ServerError = lazy(() => import('./pages/Error').then(mod => ({ default: mod.ServerError })));
const Blocked = lazy(() => import('./pages/Error').then(mod => ({ default: mod.Blocked })));
const FactoryWM = lazy(() => import('./pages/Factory').then(mod => ({ default: mod.FactoryWM })));
const FactoryHM = lazy(() => import('./pages/Factory').then(mod => ({ default: mod.FactoryHM })));
const Integration = lazy(() => import('./pages/Integration'));
const IntegrationWeak = lazy(() => import('./pages/Integration/IntegrationWeak'));
const Key = lazy(() => import('./pages/Key').then(mod => ({ default: mod.Key })));
const KeyEdit = lazy(() => import('./pages/Key').then(mod => ({ default: mod.KeyEdit })));
const KeyOut = lazy(() => import('./pages/Key').then(mod => ({ default: mod.KeyOut })));
const KeyBlacklist = lazy(() => import('./pages/Key').then(mod => ({ default: mod.KeyBlacklist })));
const KeyBlack = lazy(() => import('./pages/Key').then(mod => ({ default: mod.KeyBlack })));
const KeyParams = lazy(() => import('./pages/Key').then(mod => ({ default: mod.KeyParams })));
const Keybox = lazy(() => import('./pages/Keybox').then(mod => ({ default: mod.Keybox })));
const KeyboxData = lazy(() => import('./pages/Keybox').then(mod => ({ default: mod.KeyboxData })));
const KeyboxEdit = lazy(() => import('./pages/Keybox').then(mod => ({ default: mod.KeyboxEdit })));
const KeyboxList = lazy(() => import('./pages/Keybox').then(mod => ({ default: mod.KeyboxList })));
const Keycabinet = lazy(() => import('./pages/Keybox').then(mod => ({ default: mod.Keycabinet })));
const Lock = lazy(() => import('./pages/Lock').then(mod => ({ default: mod.Lock })));
const LockEdit = lazy(() => import('./pages/Lock').then(mod => ({ default: mod.LockEdit })));
const ELCLockEdit = lazy(() => import('./pages/Lock').then(mod => ({ default: mod.ELCLockEdit })));
const Login = lazy(() => import('./pages/Login'));
const AppLink = lazy(() => import('./pages/Mobile/AppLink'));
const Profile = lazy(() => import('./pages/Profile'));
const KeyOutIn = lazy(() => import('./pages/Record').then(mod => ({ default: mod.KeyOutIn })));
const KeyLost = lazy(() => import('./pages/Record').then(mod => ({ default: mod.KeyLost })));
const LockSwitch = lazy(() => import('./pages/Record').then(mod => ({ default: mod.LockSwitch })));
const Log = lazy(() => import('./pages/Record').then(mod => ({ default: mod.Log })));
const TaskDownload = lazy(() => import('./pages/Record/TaskDownload'));
const Role = lazy(() => import('./pages/Role').then(mod => ({ default: mod.Role })));
const RoleEdit = lazy(() => import('./pages/Role').then(mod => ({ default: mod.RoleEdit })));
const SDK = lazy(() => import('./pages/SDK'));
const AccountLockoutParams = lazy(() => import('./pages/System/AccountLockoutParams'));
const Task = lazy(() => import('./pages/Task').then(mod => ({ default: mod.Task })));
const TaskEdit = lazy(() => import('./pages/Task').then(mod => ({ default: mod.TaskEdit })));
const ELCTaskEdit = lazy(() => import('./pages/Task').then(mod => ({ default: mod.ELCTaskEdit })));
const User = lazy(() => import('./pages/User').then(mod => ({ default: mod.User })));
const UserEdit = lazy(() => import('./pages/User').then(mod => ({ default: mod.UserEdit })));
const Worker = lazy(() => import('./pages/Worker').then(mod => ({ default: mod.Worker })));
const WorkerEdit = lazy(() => import('./pages/Worker').then(mod => ({ default: mod.WorkerEdit })));
const Writer = lazy(() => import('./pages/Writer'));
const Company = lazy(() => import('./pages/Company/Company'));
const CompanyEdit = lazy(() => import('./pages/Company/CompanyEdit'));
const SoftwareSettings = lazy(() => import('./pages/Company/components/SoftwareSettings'));
const SystemSettings = lazy(() => import('./pages/Company/components/SystemSettings'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Dept = lazy(() => import('./pages/Dept').then(mod => ({ default: mod.Dept })));
const DeptDelete = lazy(() => import('./pages/Dept').then(mod => ({ default: mod.DeptDelete })));
const DeptEdit = lazy(() => import('./pages/Dept').then(mod => ({ default: mod.DeptEdit })));
const DeptBin = lazy(() => import('./pages/Dept').then(mod => ({ default: mod.DeptBin })));
const Edition = lazy(() => import('./pages/Edition/Edition'));
const Mail = lazy(() => import('./pages/System').then(mod => ({ default: mod.Mail })));
const Backup = lazy(() => import('./pages/System').then(mod => ({ default: mod.Backup })));
const Pwdlevel = lazy(() => import('./pages/System/Pwdlevel'));
const SysSet = lazy(() => import('./pages/System/SysSet'));
const ELCControllerSet = lazy(() => import('./pages/System/ELCControllerSet'));
const KeycabinetAppCenter = lazy(() => import('./pages/System/KeycabinetAppCenter'));
const BI = lazy(() => import('./pages/BI/index'));
const AppCenter = lazy(() => import('./pages/System/AppCenter'));
const CommProgram = lazy(() => import('./pages/System/CommProgram'));
const System = lazy(() => import('./pages/System').then(mod => ({ default: mod.System })));
const License = lazy(() => import('./pages/System').then(mod => ({ default: mod.License })));
const MqttPasswordEncryption = lazy(() => import('./pages/System/MqttPasswordEncryption'));
const ELCController = lazy(() =>
  import('./pages/ELCController').then(mod => ({ default: mod.ELCController }))
);
const TaskUpdating = lazy(() =>
  import('./pages/Task').then(mod => ({ default: mod.TaskUpdating }))
);
const PatrolSite = lazy(() => import('./pages/Patrol/Site'));
const PatrolSiteEdit = lazy(() =>
  import('./pages/Patrol/Site').then(mod => ({ default: mod.SiteEdit }))
);
const PatrolCollectedSite = lazy(() => import('./pages/Patrol/CollectedSite'));
const PatrolContent = lazy(() => import('./pages/Patrol/Content'));
const PatrolContentEdit = lazy(() =>
  import('./pages/Patrol/Content').then(mod => ({ default: mod.ContentEdit }))
);
const PatrolContentBind = lazy(() =>
  import('./pages/Patrol/Content').then(mod => ({ default: mod.ContentBind }))
);
const PatrolSiteContent = lazy(() =>
  import('./pages/Patrol/Site').then(mod => ({ default: mod.SiteContent }))
);
const PatrolPlan = lazy(() => import('./pages/Patrol/Plan'));
const PatrolPlanEdit = lazy(() =>
  import('./pages/Patrol/Plan').then(mod => ({ default: mod.PlanEdit }))
);
const PatrolRecords = lazy(() => import('./pages/Patrol/Records'));
const PatrolReport = lazy(() => import('./pages/Patrol/Report/Report'));
const PatrolRecordUpload = lazy(() => import('./pages/Patrol/Records/PatrolRecordUpload'));
const KeyCabinet = lazy(() =>
  import('./pages/KeyCabinet').then(mod => ({ default: mod.KeyCabinet }))
);
const KeyCabinetEdit = lazy(() =>
  import('./pages/KeyCabinet').then(mod => ({ default: mod.KeyCabinetEdit }))
);
const KeyCabinetHole = lazy(() =>
  import('./pages/KeyCabinet').then(mod => ({ default: mod.KeyCabinetHole }))
);
const CurrentLocation = lazy(() =>
  import('./pages/Lock').then(mod => ({ default: mod.CurrentLocation }))
);
const SwitchReader = lazy(() =>
  import('./pages/Record').then(mod => ({ default: mod.SwitchReader }))
);
const LockReplace = lazy(() =>
  import('./pages/Record').then(mod => ({ default: mod.LockReplace }))
);
const ELCDoorSwitch = lazy(() =>
  import('./pages/Record').then(mod => ({ default: mod.ELCDoorSwitch }))
);
const ELCAlarmData = lazy(() =>
  import('./pages/Record').then(mod => ({ default: mod.ELCAlarmData }))
);
const LockEventData = lazy(() =>
  import('./pages/Record').then(mod => ({ default: mod.LockEventData }))
);
// const LockEventDataReader = lazy(() =>
//   import('./pages/Record').then(mod => ({ default: mod.LockEventDataReader }))
// );
const ELCCabinet = lazy(() =>
  import('./pages/ELCCabinet').then(mod => ({ default: mod.ELCCabinet }))
);
const ELCCabinetEdit = lazy(() =>
  import('./pages/ELCCabinet').then(mod => ({ default: mod.ELCCabinetEdit }))
);
const ELCAssociateControllerEdit = lazy(() =>
  import('./pages/ELCCabinet').then(mod => ({ default: mod.ELCAssociateControllerEdit }))
);
const Customization = lazy(() =>
  import('./pages/System').then(mod => ({ default: mod.Customization }))
);

// 通用空加载占位符
const EmptyFallback = () => null;
// BI专用加载动画
const BILoading = () => (
  <Loading
    tip={
      <div className="load-container load1">
        <div className="loader">loading...</div>
      </div>
    }
    className="interation-loading"
  >
    <div className="demo"></div>
  </Loading>
);

const routerConfig = [
  {
    path: '/login',
    layout: BlankLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Login {...props} />
      </Suspense>
    ),
  },
  {
    path: '/integration',
    layout: BlankLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Integration {...props} />
      </Suspense>
    ),
  },
  {
    path: '/integration_weak',
    layout: BlankLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <IntegrationWeak {...props} />
      </Suspense>
    ),
  },
  {
    path: '/exception',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <ServerError {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/500',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ServerError {...props} />
          </Suspense>
        ),
      },
      {
        path: '/403',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Forbidden {...props} />
          </Suspense>
        ),
      },
      {
        path: '/204',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Empty {...props} />
          </Suspense>
        ),
      },
      {
        path: '/404',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <NotFound {...props} />
          </Suspense>
        ),
      },
      {
        path: '/blocked',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Blocked {...props} />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/basic',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <User {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/user',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <User {...props} />
          </Suspense>
        ),
        authority: Auths.queryUSER,
        keepAlive: {
          destination: '/basic/user/edit',
        },
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <UserEdit {...props} />
              </Suspense>
            ),
            authority: Auths.editUSER,
          },
        ],
      },
      {
        path: '/role',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Role {...props} />
          </Suspense>
        ),
        authority: Auths.queryROLE,
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <RoleEdit {...props} />
              </Suspense>
            ),
            // authority: Auths.editROLE,
            // TODO: 这个地方设置为查看权限是因为即使没有设置权限也应该可以看到具体权限内容;
            authority: Auths.queryROLE,
          },
        ],
      },
      {
        path: '/dept',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Dept {...props} />
          </Suspense>
        ),
        authority: Auths.queryDEPT,
        keepAlive: {
          destination: ['/basic/dept/edit', '/basic/dept/delete', '/basic/dept/bin'],
        },
        children: [
          {
            // path: '/delete/:deptid',
            path: '/delete',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <DeptDelete {...props} />
              </Suspense>
            ),
            authority: Auths.delDEPT,
          },
          {
            // path: '/edit/:deptid',
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <DeptEdit {...props} />
              </Suspense>
            ),
            authority: [Auths.addDEPT, Auths.editDEPT],
          },
          {
            path: '/bin',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <DeptBin {...props} />
              </Suspense>
            ),
            authority: Auths.binDEPT,
          },
        ],
      },
      {
        path: '/worker',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Worker {...props} />
          </Suspense>
        ),
        authority: Auths.queryWORKER,
        keepAlive: {
          destination: '/basic/worker/edit',
        },
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <WorkerEdit {...props} />
              </Suspense>
            ),
            authority: Auths.editWORKER,
          },
        ],
      },
    ],
  },

  {
    path: '/elccabinet', //  机柜管理
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <ELCCabinet {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCCabinet {...props} />
          </Suspense>
        ),
        authority: Auths.queryELCCABINET,
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCCabinetEdit {...props} />
          </Suspense>
        ),
        authority: [Auths.addELCCABINET, Auths.editELCCABINET],
      },
      {
        path: '/associatecontroller/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCAssociateControllerEdit {...props} />
          </Suspense>
        ),
        authority: Auths.bindELCCONTROLLER,
      },
    ],
  },
  {
    path: '/elccontroller', //  控制器管理
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <ELCController {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCController {...props} />
          </Suspense>
        ),
        authority: Auths.queryELCCONTROLLER,
      },
    ],
  },
  {
    path: '/cabinet', //  钥匙柜管理
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <KeyCabinet {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyCabinet {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEYCABINET,
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyCabinetEdit {...props} />
          </Suspense>
        ),
        authority: Auths.editKEYCABINET,
      },
      {
        path: '/hole/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyCabinetHole {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEYCABINETNODE,
      },
    ],
  },
  {
    path: '/box', //  钥匙盒管理
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <KeyboxList {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyboxList {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEYBOX,
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyboxEdit {...props} />
          </Suspense>
        ),
        authority: Auths.editKEYBOX,
      },
      {
        path: '/hole/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Keycabinet {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEYBOXNODE,
      },
    ],
  },
  {
    path: '/lock',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Lock {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Lock {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOCK,
        keepAlive: {
          destination: '/lock/edit',
        },
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        // 由于Router中routerConfig中的相关渲染处理在应用一加载时就已经处理完毕，所以无法直接如下语法实现动态渲染
        // component: isELC() ? ELCLockEdit : LockEdit

        // component接收的参数其实就是一个React组件
        // 为了实现基于是否是ELC模式的动态渲染，这里使用一个包装器组件，在内部实现动态判断
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            {isELC() ? <ELCLockEdit {...props} /> : <LockEdit {...props} />}
          </Suspense>
        ),
        authority: [Auths.addLOCK, Auths.editLOCK],
      },
      {
        path: '/currentlocation',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <CurrentLocation {...props} />
          </Suspense>
        ),
        authority: [Auths.addLOCK, Auths.editLOCK],
      },
    ],
  },
  {
    path: '/key',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Key {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Key {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEY,
        keepAlive: {
          destination: ['/key/edit', '/key/out', '/key/commparam'],
        },
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyEdit {...props} />
          </Suspense>
        ),
        authority: [Auths.addKEY, Auths.editKEY],
      },
      {
        path: '/params',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyParams {...props} />
          </Suspense>
        ),
        authority: Auths.setKeyParam,
      },
      // {
      //   path: '/commparam',
      //   layout: HeaderAsideFooterLayout,
      //   component: CommParamSetting,
      //   // authority: [Auths.addKEY, Auths.editKEY],
      // },
      {
        path: '/out',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyOut {...props} />
          </Suspense>
        ),
        authority: Auths.outKEY,
      },
      {
        path: '/blacklist',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyBlacklist {...props} />
          </Suspense>
        ),
        authority: Auths.queryBLACKLIST,
      },
      {
        path: '/black',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyBlack {...props} />
          </Suspense>
        ),
        authority: Auths.addBLACKLIST,
      },
    ],
  },
  {
    path: '/task',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Task {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Task {...props} />
          </Suspense>
        ),
        authority: Auths.queryTASK,
        keepAlive: {
          destination: '/task/edit',
        },
      },
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            {isELC() ? <ELCTaskEdit {...props} /> : <TaskEdit {...props} />}
          </Suspense>
        ),
        authority: [Auths.addTASK, Auths.editTASK],
      },
      {
        path: '/updating',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <TaskUpdating {...props} />
          </Suspense>
        ),
        authority: [Auths.queryTASKUPDATING],
      },
    ],
  },
  {
    path: '/patrol',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <PatrolSite {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/site',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolSite {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_SITE,
        keepAlive: {
          destination: ['/patrol/site/edit', '/patrol/site/content', '/patrol/collected-site'],
        },
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <PatrolSiteEdit {...props} />
              </Suspense>
            ),
            authority: [Auths.addPATROL_SITE, Auths.editPATROL_SITE],
          },
          {
            path: '/content',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <PatrolSiteContent {...props} />
              </Suspense>
            ),
            authority: Auths.editPATROL_SITE,
          },
        ],
      },
      {
        path: '/content',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolContent {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_CONTENT,
        keepAlive: {
          destination: ['/patrol/content/edit', '/patrol/content/bind'],
        },
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <PatrolContentEdit {...props} />
              </Suspense>
            ),
            authority: [Auths.addPATROL_CONTENT, Auths.editPATROL_CONTENT],
          },
          {
            path: '/bind',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <PatrolContentBind {...props} />
              </Suspense>
            ),
            authority: Auths.editPATROL_CONTENT,
          },
        ],
      },
      {
        path: '/collected-site',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolCollectedSite {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_COLLECTED_SITE,
      },
      {
        path: '/plan',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolPlan {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_PLAN,
        keepAlive: {
          destination: ['/patrol/plan/edit'],
        },
        children: [
          {
            path: '/edit',
            layout: HeaderAsideFooterLayout,
            component: props => (
              <Suspense fallback={<EmptyFallback />}>
                <PatrolPlanEdit {...props} />
              </Suspense>
            ),
            authority: [Auths.addPATROL_PLAN, Auths.editPATROL_PLAN],
          },
        ],
      },
      {
        path: '/records',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolRecords {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_RECORD,
      },
      {
        path: '/report',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolReport {...props} />
          </Suspense>
        ),
        authority: Auths.queryPATROL_REPORT,
      },
      {
        path: '/records/upload',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <PatrolRecordUpload {...props} />
          </Suspense>
        ),
        authority: Auths.uploadPATROL_RECORD,
      },
    ],
  },
  {
    path: '/record',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <KeyOutIn {...props} />
      </Suspense>
    ),
    children: [
      {
        path: '/operatelog/list',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyboxData {...props} />
          </Suspense>
        ),
        // authority: Auths.queryLOCK,
      },
      {
        path: '/task/download',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <TaskDownload {...props} />
          </Suspense>
        ),
        authority: Auths.queryTASK_DOWNLOAD,
      },
      {
        path: '/key/outin',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyOutIn {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEY_OUTIN,
      },
      {
        path: '/lock/switch',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <LockSwitch {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOCK_SWITCH,
      },
      {
        path: '/lock/eventdata',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <LockEventData {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOCK_EVENTDATA,
      },
      // {
      //   path: '/lock/eventdata/reader',
      //   layout: HeaderAsideFooterLayout,
      //   component: props => (
      //     <Suspense fallback={<EmptyFallback />}>
      //       <LockEventDataReader {...props} />
      //     </Suspense>
      //   ),
      //   authority: Auths.queryLOCK_EVENTDATA,
      // },
      {
        path: '/elccabinetdoor/switch',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCDoorSwitch {...props} />
          </Suspense>
        ),
        // authority: Auths.queryLOCK_SWITCH,
      },
      {
        path: '/elcalarm',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCAlarmData {...props} />
          </Suspense>
        ),
        // authority: Auths.queryLOCK_SWITCH,
      },

      {
        path: '/key/lost',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeyLost {...props} />
          </Suspense>
        ),
        authority: Auths.queryKEY_LOST,
      },
      {
        path: '/lock/reader',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <SwitchReader {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOCK_SWITCH,
      },
      {
        path: '/lock/replace',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <LockReplace {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOCK_REPLACE,
      },
      {
        path: '/log',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Log {...props} />
          </Suspense>
        ),
        authority: Auths.queryLOG,
      },
    ],
  },
  {
    path: '/company',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Company {...props} />
      </Suspense>
    ),
    authority: Auths.ADMINISTRATOR,
    children: [
      {
        path: '/edit',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <CompanyEdit {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/softwaresettings',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <SoftwareSettings {...props} />
          </Suspense>
        ),
        authority: Auths.ADMINISTRATOR,
      },
    ],
  },
  {
    path: '/settings',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <SystemSettings {...props} />
      </Suspense>
    ),
    authority: Auths.ADMINISTRATOR,
  },
  {
    path: '/',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Dashboard {...props} />
      </Suspense>
    ),
  },
  {
    path: '/bi',
    component: props => (
      <Suspense fallback={<BILoading />}>
        <BI {...props} />
      </Suspense>
    ),
  },

  {
    path: '/keybox',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Keybox {...props} />
      </Suspense>
    ),
  },
  // {
  //   path: '/hardware',
  //   layout: HeaderAsideFooterLayout,
  //   component: Hardware,
  // },
  {
    path: '/factory-wm',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <FactoryWM {...props} />
      </Suspense>
    ),
    authority: Auths.SUPER,
  },
  {
    path: '/factory-hm',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <FactoryHM {...props} />
      </Suspense>
    ),
    authority: Auths.SUPER,
  },
  {
    path: '/factory-setting-wm',
    layout: FactoryLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <FactoryWM {...props} />
      </Suspense>
    ),
    authority: Auths.SUPER,
  },
  {
    path: '/factory-setting-hm',
    layout: FactoryLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <FactoryHM {...props} />
      </Suspense>
    ),
    authority: Auths.SUPER,
  },
  {
    path: '/writer',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Writer {...props} />
      </Suspense>
    ),
    authority: [Auths.initKEY, Auths.initLOCK],
  },
  {
    path: '/sdk',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <SDK {...props} />
      </Suspense>
    ),
  },
  {
    path: '/profile',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <Profile {...props} />
      </Suspense>
    ),
    authority: Auths.USER,
    children: [
      {
        path: '/password',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Password {...props} />
          </Suspense>
        ),
        authority: Auths.USER,
      },
    ],
  },
  {
    path: '/system',
    layout: HeaderAsideFooterLayout,
    // component: System,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <System {...props} />
      </Suspense>
    ),
    authority: Auths.SUPER,
    children: [
      {
        path: '/mail',
        layout: HeaderAsideFooterLayout,
        // component: System.Mail,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Mail {...props} />
          </Suspense>
        ),
        authority: Auths.SUPER,
      },
      {
        path: '/customization',
        layout: HeaderAsideFooterLayout,
        // component: System.Customization,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Customization {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/license',
        layout: FactoryLayout,
        // component: System.License,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <License {...props} />
          </Suspense>
        ),
        // authority: Auths.SUPER,
      },
      {
        path: '/backup',
        layout: HeaderAsideFooterLayout,
        // component: System.Backup,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Backup {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/pwdlevel',
        layout: HeaderAsideFooterLayout,
        // component: Pwdlevel,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Pwdlevel {...props} />
          </Suspense>
        ),
        authority: Auths.SUPER,
      },
      {
        path: '/accountlockoutparams',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <AccountLockoutParams {...props} />
          </Suspense>
        ),
        authority: Auths.SUPER,
      },
      {
        path: '/sysset',
        layout: HeaderAsideFooterLayout,
        // component: SysSet,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <SysSet {...props} />
          </Suspense>
        ),
      },
      {
        path: '/elc/params',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <ELCControllerSet {...props} />
          </Suspense>
        ),
      },
      {
        path: '/keycabinetcenter',
        layout: HeaderAsideFooterLayout,
        // component: KeycabinetAppCenter,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <KeycabinetAppCenter {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/commprogram',
        layout: HeaderAsideFooterLayout,
        // component: CommProgram,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <CommProgram {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/appcenter',
        layout: HeaderAsideFooterLayout,
        // component: AppCenter,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <AppCenter {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
      {
        path: '/edition',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <Edition {...props} />
          </Suspense>
        ),
        authority: Auths.SUPER,
      },
      {
        path: '/mqtt/password/encryption',
        layout: HeaderAsideFooterLayout,
        component: props => (
          <Suspense fallback={<EmptyFallback />}>
            <MqttPasswordEncryption {...props} />
          </Suspense>
        ),
        authority: [Auths.SUPER, Auths.ADMINISTRATOR],
      },
    ],
  },
  {
    path: '/app',
    layout: BlankLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <AppLink {...props} />
      </Suspense>
    ),
  },
  {
    path: '*',
    layout: HeaderAsideFooterLayout,
    component: props => (
      <Suspense fallback={<EmptyFallback />}>
        <NotFound {...props} />
      </Suspense>
    ),
  },
];
export default routerConfig;

// 为了给路由加入权限使用了如下写法
// const routerData = getRouterData(routerConfig, asideMenuConfig);
// export default routerData;
